interface Props {
  size?: number;
  height?: number;
}

export const DeliveryIcon = ({ size }: Props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 1445 1024"
      width={size ? size : '30'}
      height={size ? size : '30'}
    >
      <path
        fill="#3A3A3A"
        d="m1433.299 455.078-200.885-260.82a60.24 60.24 0 0 
        0-47.887-23.49H898.41V60.234A60.235 60.235 0 0 0 
        838.174 0H60.235a60.235 60.235 0 0 0 0 
        120.47H777.94V783.06H471.34a180.706 180.706 
        0 0 0-340.33 0H60.236a60.235 60.235 0 0 0 0 
        120.47h70.777a180.706 180.706 0 0 0 340.33 
        0H914.07a180.706 180.706 0 0 0 340.329 0h131.012a60.235 
        60.235 0 0 0 60.235-60.235V491.821a62.04 62.04 0 0 
        0-12.348-36.743M301.176 903.529a60.235 60.235 0 1 1 
        60.236-60.235 60.235 60.235 0 0 1-60.236 60.235m783.06 
        0a60.235 60.235 0 1 1 60.235-60.235 60.235 60.235 0 0 
        1-60.236 60.235m240.94-120.47H1254.4a180.706 180.706 0 0 
        0-340.33 0h-15.66V291.238h256.602L1325.176 512z"
      ></path>
      <path
        fill="#3A3A3A"
        d="M45.176 348.762h404.18a45.176 45.176 0 1 0 
        0-90.353H45.175a45.176 45.176 0 0 0 0 90.353m0 
        180.706h253.591a45.176 45.176 0 1 0 0-90.353H45.177a45.176 
        45.176 0 1 0 0 90.353"
      ></path>
    </svg>
  );
};
